import Vue from 'vue';

const state = () => ({
	content: {},
	details: {},
	detailsReferences: [],
	documents: [],
	events: [],
	scopeflowsSearch: '',
	dimensionsSearch: '',
	idSearch: '',
	shipmentLoading: false
});



const mutations = {
	setContent (state, content) {
		Vue.set(state, 'content', content);
	},
	setDetails (state, details) {
		Vue.set(state, 'details', details);
	},
	setDocuments (state, documents) {
		Vue.set(state, 'documents', documents);
	},
	setEvents (state, events) {
		Vue.set(state, 'events', events);
	},
	setShipmentLoading (state, shipmentLoading) {
		state.shipmentLoading = shipmentLoading;
	},
	resetShipmentResults (state) {
		state = 	{
			content: {},
			details: {},
			documents: [],
			events: [],
			shipmentLoading: false
		};
	},
	setIdSearch (state, value) {
		state.idSearch = value;
	},
	setScopeflowsSearch (state, value) {
		state.scopeflowsSearch= value;
	},
	setDimensionsSearch (state, value) {
		state.dimensionsSearch = value;
	},
	setDetailsReferences (state, value) {
		state.detailsReferences = value;
	}
};

const actions = {
};

const getters = {
	getDocuments: state => {
		return state.documents;
	},
	getDocumentCategories: state => {
		return new Set(state.documents.map((document) => document.document_category_code));
	},
	getIdSearch: state => state.idSearch,
	getScopeflowsSearch: state => state.scopeflowsSearch,
	getDimensionsSearch: state => state.dimensionsSearch,
	getDetailsReferences: state => state.detailsReferences
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
